import { faPaperPlaneTop, faRefresh } from '@fortawesome/pro-regular-svg-icons';
import { Icon } from '@hl/ui-components';
import React from 'react';

import {
  MessageInputBoxButtons,
  MessageInputBoxTextAreaWrapper,
  MessageInputBoxWrapper,
} from './MessageInputBoxWrapper.styled';
import { useMessageInput } from './utils/useMessageInput';
import { useResetChat } from './utils/useResetChat';

export interface MessageInputBoxProps {
  minHeight?: string;
  className?: string;
  placeholder?: string;
  backgroundColor?: string;
  noBorder?: boolean;
  resetButton?: React.ReactNode;
}

export const MessageInputBox: React.FC<MessageInputBoxProps> = ({
  minHeight = '8rem',
  className = 'message-input-box',
  placeholder = 'Ask me anything...',
  backgroundColor,
  noBorder,
  resetButton
}) => {
  const { message, sendMessage, inputRefCB } = useMessageInput();
  const { resetChatSession, error } = useResetChat();

  const defaultResetButton = (
    <Icon
      className="message-input-btn reset"
      onClick={() => {
        resetChatSession();
      }}
      icon={faRefresh}
      title="Clears chat history to start a new topic"
    ></Icon>
  );

  const resetButtonToRender = resetButton !== undefined ? resetButton : defaultResetButton;

  return (
    <MessageInputBoxWrapper data-testid="messageBox" $resetError={!!error} $background={backgroundColor} $noBorder={noBorder} className={className}>
      <MessageInputBoxTextAreaWrapper $minHeight={minHeight}>
        <textarea placeholder={placeholder} ref={inputRefCB} />
      </MessageInputBoxTextAreaWrapper>
      <MessageInputBoxButtons>
        <div className='placeholder'>{resetButtonToRender}</div>
        <Icon
          icon={faPaperPlaneTop}
          onClick={sendMessage}
          className="message-input-btn"
          title="Send Message"
          disabled={!message.trim()}
        />
      </MessageInputBoxButtons>
    </MessageInputBoxWrapper>
  );
};
